import * as turf from "@turf/turf";

const COUNTRY_BBOX = {
  GR: { minLon: 19.0, minLat: 34.6, maxLon: 28.5, maxLat: 41.9 },
  FR: { minLon: -5.6, minLat: 41.0, maxLon: 9.7, maxLat: 51.6 },
};

const countryByLonLat = (lon, lat) => {
  const inBox = (b) => lon >= b.minLon && lon <= b.maxLon && lat >= b.minLat && lat <= b.maxLat;
  if (inBox(COUNTRY_BBOX.GR)) return 'GR';
  if (inBox(COUNTRY_BBOX.FR)) return 'FR';
  return 'US';
};

export const detectCountryForFeature = (feature) => {
  try {
    const [lon, lat] = turf.centroid(feature).geometry.coordinates;
    return countryByLonLat(lon, lat);
  } catch { return 'US'; }
};